module.exports = __webpack_public_path__ + "static/media/cat-with-tears-of-joy-svgrepo-com.834d94ed.svg";